export default () => ({
    job: {},
    matchedJobs: [],
    application: [],
    is_apply_enabled: true,
    show_original_posted_date: false,
});
